module.exports = __webpack_public_path__ + "static/2-2f559b29620d125c519fd0bcf5d284f1.jpg";